"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class userPresence {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.customScope = undefined;
        this.scope = {
            presence: "<",
            fontSize: "<",
        };
        this.restrict = "E";
        this.templateUrl = "assets/javascripts/xchelper/directives/userPresence.html";
        this.link = (scope, element, attrs) => {
            this.$timeout(() => {
                const customScope = scope;
                let avatarStatusDiv = element.parent()[0];
                const parentElement = avatarStatusDiv.querySelector('.avatar-circle');
                if (!avatarStatusDiv)
                    return;
                const spanToChange = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector(".contact-initials");
                if (!spanToChange)
                    return;
                const originalText = spanToChange.textContent || "";
                element.on("mouseenter", () => {
                    element[0].style.cursor = "pointer";
                    spanToChange.textContent = "";
                    spanToChange.className = "fas fa-user";
                    spanToChange.style.fontSize = customScope.fontSize;
                });
                element.on("mouseleave", () => {
                    element[0].style.cursor = "default";
                    spanToChange.textContent = originalText;
                    spanToChange.className = "";
                    spanToChange.style.fontSize = "";
                });
            }, 200);
        };
    }
}
exports.default = userPresence;
userPresence.$inject = ["$timeout"];
